import { Columns3, RotateCcw, Building2 } from 'lucide-react';
import { Button } from './ui/button';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuLabel,
  DropdownMenuSeparator, DropdownMenuCheckboxItem, DropdownMenuItem,
} from './ui/dropdown-menu';
import { INVENTORY_VIEWS } from '../hooks/useInventoryView';

export const InventoryColumnSelector = ({ view, viewState }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant="outline" size="sm" className="h-9 gap-1.5" data-testid={`${view}-column-selector`} aria-label="Choose visible columns">
        <Columns3 className="w-4 h-4" />
        <span className="hidden sm:inline">Columns</span>
        {viewState.isCustomized && <span className="w-1.5 h-1.5 rounded-full bg-primary" aria-label="Personal view" />}
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-60">
      <DropdownMenuLabel className="text-xs">Show columns</DropdownMenuLabel>
      {INVENTORY_VIEWS[view].columns.map(c => (
        <DropdownMenuCheckboxItem
          key={c.key}
          checked={viewState.isVisible(c.key)}
          disabled={c.locked}
          onCheckedChange={() => viewState.toggleColumn(c.key)}
          onSelect={(e) => e.preventDefault()}
          data-testid={`${view}-col-toggle-${c.key}`}
        >
          {c.label}
        </DropdownMenuCheckboxItem>
      ))}
      <DropdownMenuSeparator />
      <p className="px-2 py-1 text-[11px] text-muted-foreground" data-testid={`${view}-view-source`}>
        {viewState.isCustomized ? 'Your personal view' : viewState.hasCompanyDefault ? 'Company default' : 'Standard view'}
      </p>
      <DropdownMenuItem disabled={!viewState.isCustomized} onClick={viewState.resetToCompany} data-testid={`${view}-reset-view`}>
        <RotateCcw className="w-4 h-4 mr-2" /> Reset to company default
      </DropdownMenuItem>
      {viewState.canEdit && (
        <DropdownMenuItem onClick={viewState.saveAsCompany} data-testid={`${view}-save-company-default`}>
          <Building2 className="w-4 h-4 mr-2" /> Save as company default
        </DropdownMenuItem>
      )}
    </DropdownMenuContent>
  </DropdownMenu>
);
